import { render, staticRenderFns } from "./tag-navigation.vue?vue&type=template&id=43f2b00b&"
import script from "./tag-navigation.vue?vue&type=script&lang=js&"
export * from "./tag-navigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports